// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"ea1b6020","182":"7af818c3","453":"8cfa5c2e","551":"a5b93a64"}[chunkId] + ".chunk.js";
};